import { CheckAvailabilityInput } from 'gql/__generated/vp-apollo';
import { useForm, useFormContext } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { citySchema, houseNumberSchema, streetSchema, zipSchema } from '@cobra/validation/schemas';
import yup from '@cobra/validation/yup-extended';
import { useSubmissionLock } from 'hooks/form/useSubmissionLock';

const addressSearchFormSchema = yup.object().shape({
    street: streetSchema.required(),
    houseNumber: houseNumberSchema.required(),
    zip: zipSchema.required(),
    city: citySchema.required(),
});

export const useAddressSearchForm = () =>
    useForm<CheckAvailabilityInput>({
        mode: 'onSubmit',
        reValidateMode: 'onSubmit',
        resolver: yupResolver(addressSearchFormSchema),
    });

export const useAddressSearchFormContext = () => {
    const { handleSubmit, formState } = useFormContext<CheckAvailabilityInput>();
    const lockSubmission = useSubmissionLock(formState);

    return {
        handleSubmit,
        lockSubmission,
    };
};
